import { FC, useState } from 'react';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import menuBgTransparent from '../../../assets/images/menu-bg-transparent.svg';
import pvxLogo from '../../../assets/icons/pvx-logo.svg';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';

const SignupSideNav: FC = () => {
  const { t: translation } = useTranslation();
  const [languageSelectorAnchorEl, setLanguageSelectorAnchorEl] = useState<null | HTMLElement>(
    null,
  );
  const socials = [
    {
      label: translation('signup.socials.linkedIn'),
      href: 'https://www.linkedin.com/company/pvx-partners',
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#989CA21A',
        width: '18.75rem',
        borderRadius: '1rem',
        backgroundImage: `url(${menuBgTransparent})`,
        backgroundPosition: '1rem 1rem',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box
        sx={{
          height: '4.625rem',
          width: '4.625rem',
          borderRadius: '1rem',
          backgroundColor: '#101112',
          padding: '0.875rem',
          margin: '0.6875rem',
        }}
      >
        <img src={pvxLogo} alt="pvx-logo" style={{ height: '100%' }} />
      </Box>

      <Stack direction="column" spacing="2.625rem">
        {socials.map(({ label, href }, index) => (
          <Button
            disableElevation
            disableFocusRipple
            disableRipple
            disableTouchRipple
            href={href}
            key={index}
            sx={{
              textTransform: 'none',
              padding: 0,
              fontSize: '1.0625rem',
              lineHeight: '1.375rem',
              fontWeight: 550,
              color: '#101112',
              justifyContent: 'flex-start',
              ':hover': { backgroundColor: 'rgba(0,0,0,0)' },
            }}
          >
            {label}
          </Button>
        ))}
        <Typography
          sx={{
            color: '#101112',
            fontWeight: 550,
            fontSize: '1rem',

            fontFamily: 'Manrope,sans-serif',
          }}
        >
          {translation('signup.contact_us_at')}{' '}
          <Link
            href="mailto:info@pvxpartners.com"
            sx={{
              color: '#51B8B0',
              fontWeight: 700,
              fontSize: '1rem',
              lineHeight: '1.25rem',
              fontFamily: 'Manrope,sans-serif',
            }}
          >
            info@pvxpartners.com
          </Link>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '0.5rem',
          }}
        >
          <LanguageSelector
            anchorEl={languageSelectorAnchorEl}
            setAnchorEl={setLanguageSelectorAnchorEl}
            isMobile={false}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default SignupSideNav;
